import React from 'react';
import { ShieldCheck, Wrench, Star, Home, BadgePercent } from 'lucide-react';
const ITEMS = [{
  icon: ShieldCheck,
  title: 'Lifetime Warranty',
  sub: 'Clean water guaranteed.'
}, {
  icon: Wrench,
  title: 'Free Installation',
  sub: 'Pro certified techs.'
}, {
  icon: Star,
  title: '100+ 5-Star Reviews',
  sub: 'Trusted across Tulsa.'
}, {
  icon: Home,
  title: 'Family Owned',
  sub: 'Tulsa, Oklahoma based.'
}, {
  icon: BadgePercent,
  title: 'Military Discounts',
  sub: 'Veterans & first responders.'
}];
export function TrustStrip() {
  return <section className="border-b border-slate-200 bg-white" data-id="element-210" data-mp="12aupws7q5o0t">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-5 px-4 py-6 sm:px-6 md:grid-cols-3 lg:grid-cols-5" data-id="element-211" data-mp="xc9possh34cd">
        {ITEMS.map(({
        icon: Icon,
        title,
        sub
      }) => <div key={title} className="flex items-center gap-3" data-id="element-212" data-mp="nen4xpohsikh">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-cyan/10 text-brand-blue" data-id="element-213" data-mp="ngzjdsv1kass">
              <Icon className="h-5 w-5" data-id="element-214" data-mp="2nwcqiyll7b31" />
            </span>
            <div className="leading-tight" data-id="element-215" data-mp="2nurtn2bsvg20">
              <p className="text-sm font-bold text-navy-900" data-id="element-216" data-mp="2smjeqxc6stkr">{title}</p>
              <p className="text-xs text-slate-500" data-id="element-217" data-mp="2somc62fo5ozi">{sub}</p>
            </div>
          </div>)}
      </div>
    </section>;
}